import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        return false;
      }

      // Decode token to check if it's valid and not expired
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decoded.exp && decoded.exp < currentTime) {
        // Token is expired
        localStorage.removeItem('token');
        return false;
      }

      return true;
    } catch (error) {
      // Invalid token
      localStorage.removeItem('token');
      return false;
    }
  };

  if (!isAuthenticated()) {
    // Redirect to login page if not authenticated
    return <Navigate to="/auth/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
